export enum DeveloperConsoleRoutes {
  DASHBOARD = 'dashboard',
  LOGS = 'logs',
  DIAGNOSTICS = 'diagnostics',
  PERMISSIONS = 'permissions',
  PRODUCTION = 'production'
}
